import { IntegrationSystem } from '@/shared/types';

import { RouteConfig } from '../types';

export const getFullRoutePath = (system: IntegrationSystem, config: RouteConfig): string =>
  `/${system}/${config.basePath}/${config.path}`;
